// Route prefetching utilities for better performance
export const prefetchRoute = (routeImport: () => Promise<any>) => {
  // Use requestIdleCallback if available, otherwise use setTimeout
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      routeImport();
    });
  } else {
    setTimeout(() => {
      routeImport();
    }, 1);
  }
};

// Prefetch critical routes that users are likely to visit
export const prefetchCriticalRoutes = () => {
  // Only prefetch on fast connections to avoid wasting bandwidth
  if ('connection' in navigator) {
    const connection = (navigator as any).connection;
    if (connection && (connection.effectiveType === '4g' || connection.effectiveType === '3g')) {
      // Prefetch most commonly used routes
      prefetchRoute(() => import('../pages/Dashboard'));
      prefetchRoute(() => import('../pages/JobPostings'));
      prefetchRoute(() => import('../pages/Applications'));
      prefetchRoute(() => import('../pages/Profile'));
    }
  } else {
    // Fallback for browsers without Network Information API
    // Only prefetch the most critical route
    prefetchRoute(() => import('../pages/Dashboard'));
  }
};

// Prefetch routes on user interaction (hover, focus)
export const prefetchOnInteraction = (routeImport: () => Promise<any>) => {
  let prefetched = false;
  
  const prefetch = () => {
    if (!prefetched) {
      prefetched = true;
      prefetchRoute(routeImport);
    }
  };

  return {
    onMouseEnter: prefetch,
    onFocus: prefetch,
  };
};

// Hook for component-level prefetching
export const usePrefetch = (routeImport: () => Promise<any>, immediate = false) => {
  const prefetch = () => prefetchRoute(routeImport);
  
  if (immediate) {
    prefetch();
  }
  
  return prefetch;
};